import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  children: ReactNode;
  /** Rota do botão voltar; sem ela o botão não aparece. */
  backTo?: string;
  title?: string;
};

export function DemoLayout({ children, backTo, title }: Props) {
  const navigate = useNavigate();
  return (
    <Box className="demo-layout">
      <Box className="demo-layout__inner">
        <Box className="demo-layout__top">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {backTo !== undefined && (
              <IconButton aria-label="Voltar" onClick={() => navigate(backTo)} size="small">
                <ArrowBackIcon />
              </IconButton>
            )}
            {title && (
              <Typography component="span" sx={{ fontWeight: 600 }}>
                {title}
              </Typography>
            )}
          </Box>
          <span className="demo-badge" title="Registros demonstrativos — sem vínculo com eventos">
            Demo
          </span>
        </Box>
        <Box component="main" className="demo-layout__content">
          {children}
        </Box>
        <Box component="footer" className="demo-layout__footer">
          <span>Identila · demonstração comercial</span>
          <Box component="img" src="/brand/icon_black.png" alt="Identila" sx={{ height: 20 }} />
        </Box>
      </Box>
    </Box>
  );
}
